<template>
  <div>
    <page-header :title="$t('scope.text_283')" :tabs="cloudEnvOptions" :current-tab.sync="cloudEnv" />
    <page-body>
      <tenant-list :id="listId" :getParams="getParams" :cloud-env="cloudEnv" />
    </page-body>
  </div>
</template>

<script>
import TenantList from './components/List'

export default {
  name: 'tenantManagerIndex',
  components: {
    TenantList,
  },
  data () {
    return {
      listId: 'tenantList',
      getParams: {
        details: true,
      },
      cloudEnvOptions: [
        { key: '', label: this.$t('scope.text_515') },
        { key: 'certified', label: this.$t('scope.text_927') },
        { key: 'uncertified', label: this.$t('scope.text_632') },
        { key: 'certificating', label: this.$t('scope.text_928') },
      ],
      cloudEnv: '',
    }
  },
}
</script>
